<template>
  <div class="form-control-wrapper flex" :class="cssClasses, errors, alignment">
    <div class="form-control-label" v-show="!labelAsPlaceholder">{{ label }}</div>
    
    <slot name="input-slot"></slot>

    <div v-show="hasError" class="error-cont" >
    </div>

  </div>
</template>

<script>

export default {
  name: 'InputVue',

  props: {
    name: String,
    label: String,
    cssClasses: String,
    labelAsPlaceholder: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    alignment: {
      type: String,
      default: 'horizontal',
    },
  },

  data() {
    return {
    }
  },

  computed: {
    errors() {
      return { error: this.hasError }
    },
  },

  methods: {
    toggleError() {
      this.hasError = !this.hasError
    },

    updateValue(evt) {
      this.$emit('update:modelValue', evt.target.value)
    },

    getValue() {
    },

    reset() {
    },
  },
  
  created() {
  },
}
</script>

<style lang="scss">
.form-control-wrapper {
  position: relative; 
  //margin: $marginSmall 0;

  &.vertical {
    flex-direction: column;
  }

  .form-control-label {
    margin-bottom: $marginXSmall;
  }

  .form-control {
    width: 100%;
    font-size: $fontSize;
    padding: 0.25em 0.5em;
    color: color(color-tertiary);
    background-color: color(surface-container);
    border: 2px solid color(surface-container-highest);
    border-radius: $borderRadius;

    &:focus,
    &:focus-visible {
      border-color: color(primary);
      //box-shadow: 0 0 0 3px color(primary);
      border-radius: $borderRadius;
      outline: none;
    }

    &:not(textarea) {
      line-height: 1;
      height: 2.25em;
    }

    &input[type="file"] {
      font-size: 0.9em;
      padding-top: 0.35rem;
    }

    &[readonly] {
      cursor: not-allowed;
      color: color(outline);
    }

    &.error {
      border-color: color(error);
    }
  }

  textarea.input {
    resize: vertical;
  }
}
</style>
